import { useEffect, useState } from 'react';
import { checkUserBySession } from '../../../domain/services/authService';

export const useDiarySectionPage = () => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadUser = async () => {
            try {
                const sessionUser = await checkUserBySession();
                if (!sessionUser) {
                    window.location.href = '/auth';
                    return;
                }
                setUser(sessionUser);
            } catch (error) {
                window.location.href = '/auth';
            } finally {
                setIsLoading(false);
            }
        };

        loadUser();
    }, []);

    return { user, isLoading };
};
